import React, { useState, useEffect } from "react";
import Page from "../../../components/Page";
import Loader from "../../../components/Loader/Loader";
import {
  getSubscriptionPaymentDetails,
  getSubscriptionPaymentDetailsClear,
} from "../../../redux/subscription/actions";
import { useDispatch, useSelector } from "react-redux";
import { SessionKeys } from "../../../utils/AppUtils";
import _ from "lodash";

const SubscriptionPaymentsPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [paymentsData, setPaymentsData] = useState([]);
  const [originalPaymentsData, setOriginalPaymentsData] = useState([]);

  const dispatch = useDispatch();

  const response = useSelector(
    (state) => state.subscription.getSubscriptionPaymentDetails
  );

  useEffect(() => {
    ApiCall();
    return () => {
      dispatch(getSubscriptionPaymentDetailsClear());
    };
  }, []);

  const ApiCall = () => {
    setIsLoading(true);
    dispatch(
      getSubscriptionPaymentDetails({
        module: "subscriptionPaymentDetails",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        },
      })
    );
  };

  useEffect(() => {
    if (!_.isEmpty(response)) {
      if (response?.status === "success") {
        let data = response?.payload?.payload;
        setPaymentsData(data);
        setOriginalPaymentsData(data);
        console.log("res---", response);
        setIsLoading(false);
      } else {
        setPaymentsData([]);
        setOriginalPaymentsData([]);
        setIsLoading(false);
      }
    }
    return () => {};
  }, [response]);

  const downloadPDF = async (pdfUrl, id) => {
    setIsLoading(true);
    try {
      const response = await fetch(pdfUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      const fileURL = new URL(pdfUrl);
      const filename = fileURL.pathname.split("/").pop();

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Failed to download PDF:", error);
    }
    setIsLoading(false);
  };
  const renderTable = () => {
    return (
      <>
        <div className="row my-team-table">
          <div className="col-lg-12 col-md-12">
            <div className="course-info-table">
              {paymentsData.length > 0 ? (
                <table className="table mb-0 office_list table-striped">
                  <thead>
                    <tr>
                      <th style={{ minWidth: "270px" }}>Plan Name</th>
                      <th style={{ minWidth: "130px" }}>Invoice Date</th>
                      <th style={{ minWidth: "130px" }}>End Date</th>
                      <th style={{ minWidth: "130px" }}>Renewal Date</th>
                      <th style={{ width: "auto" }}>Invoice Amount</th>
                      <th style={{ width: "auto" }}>Download Invoice</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymentsData?.map((item, index) => {
                      return (
                        <tr className="addBGcustomw">
                          <td className="itmeeeamil">{item?.plan_name}</td>
                          <td className="itmeeeamil">{item?.invoice_date}</td>
                          <td className="itmeeeamil">{item?.end_date}</td>
                          <td className="itmeeeamil">{item?.renewal_date}</td>
                          <td className="otemrole">
                            CA ${item?.invoice_amount}
                          </td>
                          <td
                            className="officename text-center cursor-pointer"
                            onClick={() =>
                              downloadPDF(item?.download_url, item?.id)
                            }
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="#6941C6"
                            >
                              <path d="M13 12H16L12 16L8 12H11V8H13V12ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"></path>
                            </svg>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <div className="not-found cart-notfound">
                  <div className="interboxes">
                    <img src="/images/telescope.svg" alt="Not Found" />
                    <p>
                      Currently, there are no subscription payments available.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

  const searchTable = () => {
    setIsLoading(true);
    if (
      searchValue === "" ||
      searchValue === "undefined" ||
      searchValue === null
    ) {
      setPaymentsData(originalPaymentsData);
    } else {
      let searchedData = [];
      let data = originalPaymentsData;
      for (let item of data) {
        if (_.toLower(item?.plan_name)?.includes(_.toLower(searchValue))) {
          searchedData.push(item);
        }
      }
      setPaymentsData(searchedData);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (_.isEmpty(searchValue)) {
      setPaymentsData(originalPaymentsData);
    }
  }, [searchValue]);

  return (
    <Page>
      <Loader start={isLoading} />

      <section className="my-credit-points learningpaths">
        <div className="container">
          <div className="row ">
            <div className="col-md-12">
              <div className="search_heading">
                <p className="lable-heading_search">Subscription Payments</p>
              </div>
              <div className="d-flex justify-content-end">
                <div className="confirm-row m-0">
                  <input
                    type="search"
                    id="search"
                    name="search"
                    className="form-control"
                    autocomplete="off"
                    value={searchValue}
                    onChange={(evt) => {
                      setSearchValue(evt.target.value);
                    }}
                  />
                  <button className="confirm-btn" onClick={searchTable}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.16667 1.66669C5.02454 1.66669 1.66667 5.02455 1.66667 9.16669C1.66667 13.3088 5.02454 16.6667 9.16667 16.6667C10.9375 16.6667 12.565 16.053 13.8481 15.0266L16.9107 18.0893C17.2362 18.4147 17.7638 18.4147 18.0893 18.0893C18.4147 17.7638 18.4147 17.2362 18.0893 16.9108L15.0266 13.8481C16.0529 12.565 16.6667 10.9375 16.6667 9.16669C16.6667 5.02455 13.3088 1.66669 9.16667 1.66669ZM3.33334 9.16669C3.33334 5.94503 5.94501 3.33335 9.16667 3.33335C12.3883 3.33335 15 5.94503 15 9.16669C15 12.3883 12.3883 15 9.16667 15C5.94501 15 3.33334 12.3883 3.33334 9.16669Z"
                        fill="black"
                      ></path>
                    </svg>
                    Search
                  </button>
                </div>
              </div>
            </div>

            <div className=" my_learningpath_tab mt-1">{renderTable()}</div>
          </div>
        </div>
      </section>
    </Page>
  );
};

export default SubscriptionPaymentsPage;
